import React, { useEffect, useState } from 'react'
import Draggable from 'react-draggable'
import { observer } from 'mobx-react'

import Magnifier from 'react-magnifier'
import styled from 'styled-components'


// @ts-ignore
const WindowImage = observer((props) => {
  const [active, setActive] = useState(false)

  const imageSize = Math.min(props?.width, props?.height) //Меньшее значение из высоты и ширины

  const onStart = () => setActive(true)
  const onStop = () => setActive(false)
  const dragHandlers = { onStart, onStop }

  useEffect(() => {
    props.magnifier && props.setZoom(props.id, 1)
  }, [props.magnifier])

  return props.imageSrc ? (
    <div className='window '>
      {!props.magnifier ? (
        <Draggable {...dragHandlers} scale={props?.styles?.zoom}>
			<div draggable={false}>
				<div draggable={false} style={{
					transform: `scaleX(${props?.styles?.scaleX}) scaleY(${props?.styles?.scaleY}) rotate(${props?.styles?.rotate}deg)`
				}}>
					{props.imageSrc && (
						<StyledImage
						  draggable={false}
						  width={imageSize}
						  height={imageSize}
						  src={props.imageSrc}
						  active={active}
						  alt={''}
						  className={'windowImage'}
						/>
					)}
				</div>
			</div>
        </Draggable>
      ) : (
        <Magnifier
          src={props.imageSrc}
          className={'windowImage'}
          width={imageSize}
          height={imageSize}
          mgShape={'square'}
          mgHeight={imageSize / 4}
          mgWidth={imageSize / 4}
        />
      )}

      <style jsx>{`
        .window {
          zoom: ${props?.styles?.zoom};
          cursor: ${active ? 'grabbing' : 'grab'};
          filter: brightness(${props?.styles?.brightness}) contrast(${props?.styles?.contrast}) invert(${props?.styles?.invert ? '100%' : '0'});
		  iitransform: scaleX(${props?.styles?.scaleX}) scaleY(${props?.styles?.scaleY}) rotate(${props?.styles?.rotate}deg);
          position: absolute;
          transition: 400ms;
          
        }

        .window img {
          object-fit: cover;
          transition: ${active ? '0ms' : '600ms'};
          z-index: 100;
        }
      `}</style>
    </div>
  ) : (
    ''
  )
})

const StyledImage = styled.div`
  background-image: url(${p => p.src});
  width: ${p => p.width}px;
  height: ${p => p.height}px;
  background-size: contain;
  transition: ${p => p.active ? '0' : '500ms'};
`
export default WindowImage
